import React, { useState, useEffect } from 'react';
import Products from '../ProductCarousal1/Products';
import './Searchproduct.css'
import searchicon from '../Images/searchicon.png';
import { useCart } from '../AddToCart/CartContext';
import { useNavigate } from 'react-router-dom';  

const Searchproduct = ({ productData, onListVisibilityChange  }) => {
  const { addToCart} = useCart();
  const [searchQuery, setSearchQuery] = useState('');
  const [isListVisible, setIsListVisible] = useState(false);


  // const filterProducts = (products, query) => {
  //   return products.filter(product => product.name.toLowerCase().includes(query.toLowerCase()));
  // };

  // const filterProducts = (products, query) => {
  //   return products.filter(product => {
  //     // Check if product.name exists and is a string
  //     if (product.name && typeof product.name === 'string') {
  //       return product.name.toLowerCase().includes(query.toLowerCase());
  //     }
  //     return false; // Exclude products without a valid name
  //   });
  // };
  
  const filterProducts = (products = [], query = '') => {
    return products.filter(product => 
      typeof product.name === 'string' && product.name.toLowerCase().includes(query.toLowerCase())
    );
  };
  

  const filteredProducts = filterProducts(productData, searchQuery);
  console.log(localStorage.getItem("productData")); // Check saved data
console.log("check data",productData); // Ensure it's correctly parsed

  const handleDocumentClick = (e) => {
    // Check if the clicked element is outside the search container
    if (!e.target.closest('.search-products-container')) {
      setIsListVisible(false);

      onListVisibilityChange(false); // Notify parent (App.js)
    }
  };

  useEffect(() => {
    // Add event listener when the component mounts
    document.addEventListener('click', handleDocumentClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []); 

  const navigate = useNavigate();
  const handleSearchSubmit = () => {
    if (!searchQuery.trim()) return;
    // Close dropdown and navigate
    setIsListVisible(false);

    onListVisibilityChange(false); // Notify parent (App.js)

    navigate('/search-results', { state: { query: searchQuery, products: filteredProducts } });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // e.preventDefault();
      handleSearchSubmit();
    }
  };

  const handleCloseList = () => {
    setIsListVisible(false);

    onListVisibilityChange(false); // Notify parent (App.js)
    setSearchQuery(''); // Reset the search query
  };

  useEffect(() => {
    // Notify parent (App.js) whenever the list visibility changes
    onListVisibilityChange(isListVisible);
  }, [isListVisible, onListVisibilityChange]);

  // List open/close hone par background ko scroll aur pointer events disable/enable karein
  useEffect(() => {
    if (isListVisible && searchQuery) {
      document.body.style.overflow = 'hidden'; // Background scroll disable
      document.body.style.pointerEvents = 'none'; // Background click disable
    } else {
      document.body.style.overflow = 'auto'; // Background scroll enable
      document.body.style.pointerEvents = 'auto'; // Background click enable
    }

    // Cleanup function: Component unmount hone par background ko wapas enable karein
    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.pointerEvents = 'auto';
    };
  }, [isListVisible, searchQuery]);

  const handleProductClick = (Id) => {
    navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
    handleCloseList();
  };
  

  return (
    <>
    <div className={`search-products-container ${isListVisible  ? 'show-list' : ''}`}>

      {/* {searchQuery.trim() ? (
        <button onClick={handleSearchSubmit} className="search-btn">Search</button>
      ) : (
      <span className="search-icon" onClick={handleSearchSubmit}>
        <img src={searchicon} alt="search icon" />
      </span>
       )} */}
       <i className="ri-search-line" />

      <input
        type='text'
        className='searchbar'
        placeholder='Search item'
        value={searchQuery}
        onChange={(e) => {
            setSearchQuery(e.target.value);
            setIsListVisible(true); // Show the list when typing in the search bar
          }}
        onKeyDown={handleKeyDown}
      />
     {/* <button onClick={handleSearchSubmit}>Search</button> */}

      {isListVisible && searchQuery && (
        <div className="item-list">
          
          {/* <button onClick={handleCloseList}>Close</button> */}
          <div className='search-results-controls'>
            <i class="ri-close-circle-fill" 
              onClick={handleCloseList} 
            ></i>

            <button onClick={handleSearchSubmit} className="search-btn">
              Search
            </button>
  
            <button onClick={handleSearchSubmit} 
                 className='search-results-view-all'>
                  View All
            </button>
          </div>

          <div className='search-product-item'>
            <ul className="search-product-list">
          {filteredProducts.map((item) => (
            <li
              key={item.id}
              onClick={() => handleProductClick(item.id)} 
             >
              <img src={item.imageUrl[0]} alt={item.name} />
              <div>
                <h4 >{item.title}</h4>
                {/* <h4 >{item.name}</h4> */}
                {/* <p> Price: {item.price}</p> */}
                {item.discountPrice && item.discountPrice > 0 ? (
                  <>
                    <p className="search-product-price">
                      Rs. {item.price}
                    </p>
                    <p className="search-product-discount-price">
                      Rs. {item.discountPrice}
                    </p>
                  </>
                ) : (
                      <p className="search-product-discount-price">Rs.{item.price}</p>
                    )}
              </div>
            </li>
             
            


            // <li key={item.id}  
            //     onClick={handleCloseList}
            //     className="search-products-item"
            //     style={{width: 'fit-content', backgroundColor:'aqua'}}
            // >
              
            // <Products
            //   key={item.id}
            //   id={item.id}
            //   name={item.name}
            //   imageUrl={item.imageUrl}
            //   price={item.price}
            //   addToCart={addToCart}
            // />
            // </li>
          ))}
          </ul>
           </div>
          {/* <div style={{marginBottom:'130px'}}></div> */}
        </div>
        
      )}
    </div>
    </>
  );
};

export default Searchproduct;
